export default __webpack_public_path__ + "static/media/gallery_04.ffa011d4.jpg";